import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primaryRB: '#e60028',
        primaryUC: '#007A91',
      },
    },
  },
};

export default new Vuetify(opts);

const customSlider = Vue.extend({
  extends: Vue.component('VSlider'),
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(oldVal) {
        const {
          min, max, step, snap,
        } = this;

        let val = oldVal;

        if (oldVal < min) {
          val = min;
        } else if (oldVal > max) {
          val = max;
        }

        if (Math.round(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        const value = snap ? Math.round(val / step) * step : parseInt(val, 10);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      },
    },
  },
});

Vue.component('customSlider', customSlider);
